import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedGameRunId: null,
  selectedGroupId: null,
};

const animatorSlice = createSlice({
  name: 'animator',
  initialState,
  reducers: {
    setSelectedGameRun: (state, action) => {
      state.selectedGameRunId = action.payload;
      // Reset group when game run changes
      state.selectedGroupId = null;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroupId = action.payload;
    },
    clearSelection: (state) => {
      state.selectedGameRunId = null;
      state.selectedGroupId = null;
    },
  },
});

export const { setSelectedGameRun, setSelectedGroup, clearSelection } = animatorSlice.actions;

export const selectSelectedGameRunId = (state) => state.animator.selectedGameRunId;
export const selectSelectedGroupId = (state) => state.animator.selectedGroupId;

export default animatorSlice.reducer;
